import {Box, Grid, styled, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {AccessTimeRounded, CalendarTodayRounded} from "@mui/icons-material";
import {useEffect, useState} from "react";
import {getPosts, getUpcomingEvent} from "../services/facebookService";

const Container = styled(Box)(() => ({
  backgroundSize: 'cover',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '80px 20px',
  position: 'relative',
}));

const StyledBox = styled(Box)(({theme}) => ({
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

const ImageContainer = styled(Box)(({ theme }) => ({
  maxHeight: 460,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.up('md')]: {
    minWidth: 420,
  },
}));

const Image = styled('img')(() => ({
  maxWidth: '100%',
  maxHeight: 'inherit',
  borderRadius: '8px',
}));

const Title = styled(Typography)(() => ({
  fontWeight: 600,
  textTransform: 'uppercase',
}));

const EventSection = () => {
  const [event, setEvent] = useState(null)
  const {t} = useTranslation();

  useEffect(() => {
    (async () => {
      setEvent(await getUpcomingEvent());
    })();
  }, []);
  
  if (!event) return null;
  
  return (
    <Container>
      <Grid width={1200} container spacing={2}>
        <Grid item xs={12} md={6}>
          <ImageContainer>
            <Image src={event.image} alt="event_image" />
          </ImageContainer>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box sx={{ p: 4 }}>
            <Box display="flex" alignItems="center" gap={1}>
              <CalendarTodayRounded />
              <Title variant="subtitle1">{event.title}</Title>
            </Box>
            <Box sx={{ mb: 4, mt: 1, color: '#9a9a9a' }} display="flex" alignItems="center" gap={1}>
              <AccessTimeRounded />
              <Title variant="caption">{event.date}</Title>
            </Box>
            {event.descriptionLines.map((line, index) => (
              <>
                <Typography key={index} variant="h5">{line}</Typography>
                <br />
              </>
            ))}
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default EventSection;
